import { selectAccountState } from "../accountSelectors";
import { createSelector } from "reselect";
export const selectDocumentState = createSelector(selectAccountState, account => account.documents);
export const selectDocument = createSelector(selectDocumentState, (documents) => documents.list);
